module.exports = __webpack_public_path__ + "img/yandex-metrika.92110ad0.png";